module.exports = __webpack_public_path__ + "img/English.eb6ea10e.svg";